/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : spinner.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author Tahir Shaik - tahir@au79consulting.com
 * @date 11-06-2024
 * @description Spinner Reducer -> Based on the Spinner Action it change the state of the spinner variable in store
 */
import actionType from "../actionTypes";

const initialState = {
  error: "",
  msg: "",
  isLoading: false,
  loadingCount: 0,          // completed APIs
  totalLoadingCounts: 0,    // active APIs
};

const spinnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SPINNER_LOADING: {
      const increment = action.payload?.totalLoadingCounts ?? 1;
      const newTotal = state.totalLoadingCounts + increment;

      return {
        ...state,
        totalLoadingCounts: newTotal,
        isLoading: newTotal > 0,
      };
    }

    case actionType.SPINNER_LOADED: {
      const newTotal = Math.max(0, state.totalLoadingCounts - 1);

      return {
        ...state,
        totalLoadingCounts: newTotal,
        loadingCount: state.loadingCount + 1,
        isLoading: newTotal > 0,
      };
    }

    default:
      return state;
  }
};

export default spinnerReducer;
